const TemperatureIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 7C10.5523 7 11 7.44772 11 8V12.8203C11 13.0321 11.1353 13.2178 11.3252 13.3115C12.3169 13.8007 13 14.8194 13 16C13 17.6569 11.6569 19 10 19C8.34315 19 7 17.6569 7 16C7 14.8194 7.68312 13.8007 8.6748 13.3115C8.86474 13.2178 9 13.0321 9 12.8203V8C9 7.44772 9.44772 7 10 7Z"
      fill="#161616"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C12.7614 0 15 2.23858 15 5V10.6963C15 10.9579 15.1054 11.2071 15.2773 11.4043C16.3486 12.6331 17 14.2404 17 16C17 19.866 13.866 23 10 23C6.13401 23 3 19.866 3 16C3 14.2404 3.65139 12.6331 4.72266 11.4043C4.89455 11.2071 5 10.9579 5 10.6963V5C5 2.23858 7.23858 0 10 0ZM10 2C8.34315 2 7 3.34315 7 5V11.5293C6.99986 11.8134 6.87876 12.084 6.66699 12.2734C5.64249 13.1905 5 14.5195 5 16C5 18.7614 7.23858 21 10 21C12.7614 21 15 18.7614 15 16C15 14.5195 14.3575 13.1905 13.333 12.2734C13.1212 12.084 13.0001 11.8134 13 11.5293V5C13 3.34315 11.6569 2 10 2Z"
      fill="#161616"
    />
    <path
      d="M20 8C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H17V8H20Z"
      fill="#161616"
    />
    <path
      d="M20 5C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H17V5H20Z"
      fill="#161616"
    />
    <path
      d="M20 2C20.5523 2 21 2.44772 21 3C21 3.55228 20.5523 4 20 4H17V2H20Z"
      fill="#161616"
    />
  </svg>
);

export default TemperatureIcon;
